import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router, NavigationStart } from '@angular/router';

import { tap, filter, takeUntil } from 'rxjs/operators';

import { DlgStorePixelComponent } from './dlg-store-pixel';
import { TRANSFER_PIXELS } from './dlg-store-pixel';
export { TRANSFER_PIXELS } from './dlg-store-pixel';

import { SteamService } from '../shared-services.module/steam.service';

import { ToastrService } from '../toastr.module/toastr.service';
import { ToastTransferingPixelComponent } from '../toastr.module/toast-transfering-pixel.component';
import { ToastSuccessPixelComponent } from '../toastr.module/toast-success-pixel.component';

const PKG_PIXEL = 'pixel';

interface IDlgStorePixelData {
    steam: any;
    amount: number;
}

@Injectable()
export class ShowDlgStorePixelService {
    dialogRef: MatDialogRef<DlgStorePixelComponent>;

    resolve: (value?: any) => void;
    reject: (reason?: any) => void;

    set disabled(value: boolean) {
        if (this.dialogRef.componentInstance) {
            this.dialogRef.componentInstance.disabled = value;
        }
    }

    constructor(
        private _router: Router,
        private _dialog: MatDialog,

        private _toastrSrv: ToastrService,
        private _steamSrv: SteamService,
    ) {
    }

    show(data: IDlgStorePixelData): Promise<any> {
        this.dialogRef = this._dialog.open(DlgStorePixelComponent, {
            backdropClass: 'mat-backdrop--long-scroll',
            panelClass: ['--ui'],
            data: {
                ...data,

                close: () => this.close(),
                transfer: (...args) => this.transfer(args[0])
            }
        });

        this._router.events
            .pipe(takeUntil(this.dialogRef.afterClosed()))
            .pipe(filter(e => e instanceof NavigationStart))
            .pipe(tap(() => this.close()))
            .subscribe();

        return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }

    close() {
        this.dialogRef.close();
    }

    async transfer(count: any) {
        this.dialogRef.close();

        const toastTransferingRef = this._toastrSrv.show(ToastTransferingPixelComponent, {
            timeout: 3000,
            data: {
                transfering: count
            }
        });

        try {
            await this._steamSrv.pushResources({ resourceType: PKG_PIXEL, amount: count });
        } catch (err) {
            console.error('inventory/base::dlgStorePixelSrv', err);
            this.reject(err);
            return;
        }

        toastTransferingRef.close();

        this._toastrSrv.show(ToastSuccessPixelComponent, {
            data: {
                count,
                message: 'transfered to Steam'
            }
        });

        this.resolve({ type: TRANSFER_PIXELS, payload: count });
    }
}
